export const orderedUnterrichtszeit: { bezeichnung: string; id: number }[] = [
  { bezeichnung: 'Vollzeit', id: 1 },
  { bezeichnung: 'Teilzeit', id: 2 }
];

export const orderedVorortLernformen: { bezeichnung: string; id: number }[] = [
  { bezeichnung: 'Präsenzunterricht', id: 101 },
  { bezeichnung: 'Seminar', id: 102 },
  { bezeichnung: 'Workshop', id: 103 },
  { bezeichnung: 'Praxistraining', id: 104 },
  { bezeichnung: 'Sonstige Präsenzveranstaltungen', id: 105 }
];

export const orderedDigitaleLernformen: { bezeichnung: string; id: number }[] = [
  { bezeichnung: 'Virtuelles Klassenzimmer', id: 201 },
  { bezeichnung: 'Online-Seminar', id: 202 },
  { bezeichnung: 'Online-Coaching', id: 203 },
  { bezeichnung: 'Selbstlernmodul', id: 204 },
  { bezeichnung: 'Virtual Reality', id: 205 },
  { bezeichnung: 'Sonstige digitale Lernformen', id: 206 }
];

export const orderedFernLernformen: { bezeichnung: string; id: number }[] = [
  { bezeichnung: 'Fernunterricht', id: 401 },
  { bezeichnung: 'Fernlehrgang', id: 402 },
  { bezeichnung: 'Sonstiger Fernunterricht', id: 403 }
];

export const orderedKombiLernformen: { bezeichnung: string; id: number }[] = [
  { bezeichnung: 'Blended Learning', id: 301 },
  { bezeichnung: 'Combined Learning', id: 302 },
  { bezeichnung: 'Hybrid Learning', id: 303 },
  { bezeichnung: 'Sonstige kombinierte Lernformen', id: 304 }
];

export const groupedOrderedLernformen: { bezeichnung: string; id: string; ids: number[] }[] = [
  {
    id: 'VORORT',
    bezeichnung: 'Lernen vor Ort',
    ids: orderedVorortLernformen.map(({ id }) => id)
  },
  {
    id: 'DIGITAL',
    bezeichnung: 'Online Lernen',
    ids: orderedDigitaleLernformen.map(({ id }) => id)
  },
  {
    id: 'KOMBI',
    bezeichnung: 'Hybrides Lernen',
    ids: orderedKombiLernformen.map(({ id }) => id)
  },
  {
    id: 'FERN',
    bezeichnung: 'Fernunterricht',
    ids: orderedFernLernformen.map(({ id }) => id)
  }
];
